import {
  checkUserInfo
} from '@/api/team'
const state = {
  namespaced: true,
  state: {
    userBasicInfo: {
      email: '',
      password: 'Waiting for Verification', // 根据eamil判断是否注册，否,默认密码command123
      phone: '',
      firstName: '',
      lastName: ''
    },
    addCallBack: false, // 是否已经添加
    defaultPassword: 'command123',
    identity: ''  // 判断当前添加的类型,根据打开的页面的地址判断
    // userList: []
  },
  mutations: {
    SET_ADD_CALL_BACK(state, type) {
        state.addCallBack = type
    },
    SET_IDENTITY(state, info) {
        state.identity = info
    },
  },
  actions: {
    updateIdentity({ commit }, info) {
      commit('SET_IDENTITY', info)
    },
    updateAddCallBack({ commit }, type) {
      commit('SET_ADD_CALL_BACK', type)
    },
    checkEmail(content, list) {
      return checkUserInfo(list).then(res => {
        console.log(res, '13231231')
        return res.res.data.data
      })
    }
  }
}
export default state